import React, { useState, ReactNode } from 'react';

interface TooltipProps {
  content: ReactNode;
  position?: 'TopCenter' | 'BottomCenter' | 'LeftCenter' | 'RightCenter' | string;
  children: ReactNode;
}

export const TooltipComponent = ({ content, position = 'TopCenter', children }: TooltipProps) => {
  const [visible, setVisible] = useState(false);

  const show = () => setVisible(true);
  const hide = () => setVisible(false);

  let style: React.CSSProperties = {
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 'calc(100% + 8px)'
  };

  if (position && position.toLowerCase().startsWith('bottom')) {
    style = { left: '50%', transform: 'translateX(-50%)', top: 'calc(100% + 8px)' };
  } else if (position && position.toLowerCase().startsWith('left')) {
    style = { right: 'calc(100% + 8px)', top: '50%', transform: 'translateY(-50%)' };
  } else if (position && position.toLowerCase().startsWith('right')) {
    style = { left: 'calc(100% + 8px)', top: '50%', transform: 'translateY(-50%)' };
  }

  return (
    <div
      className="relative inline-block"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      tabIndex={0}
    >
      {children}
      {visible && (
        <div
          style={style}
          className="absolute z-50 bg-gray-700 text-white text-sm rounded px-2 py-1 whitespace-nowrap"
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default TooltipComponent;
